import styled from 'styled-components'
import { ReactComponent as ArrowCircleIcon } from '@sketch/icons/arrow-right-circle-semifilled-17'

export const ContentLayout = styled.div`
  display: flex;
  font-size: ${({ theme }) => theme.fontSizes.C};
  align-items: center;
`

export const ChildrenContainer = styled.div`
  flex-grow: 1;
`

export const NoticeIcon = styled.svg`
  width: 17px;
  height: 17px;
  flex-shrink: 0;
  margin-right: 8px;
  color: var(--notice__icon);
`

export const StyledArrowCircleIcon = styled(ArrowCircleIcon)`
  width: 17px;
  height: 17px;
`
